<template>
  <Dropdown
    trigger="click"
    class="rp-insert-memory-dropdown"
    transfer-class-name="rp-insert-memory-transfer"
    :placement="placement"
    @on-click="onSelect"
  >
    <Button
      type="default"
      size="small"
      class="rp-insert-memory-btn"
      :class="{ 'rp-insert-memory-btn--footer': buttonStyle === 'footer' }"
    >+ 插入记忆</Button>
    <DropdownMenu slot="list">
      <DropdownItem
        v-for="item in memoryOptions"
        :key="item.token"
        :name="item.token"
        class="rp-insert-memory-item"
      >
        <span class="rp-insert-memory-row">
          <span class="rp-insert-memory-row__token">{{ item.token }}</span>
          <span class="rp-insert-memory-row__label">{{ item.label }}</span>
        </span>
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import { MEMORY_INSERT_OPTIONS } from '../../utils/callControlHelpers'

export default {
  name: 'LlmInsertMemoryDropdown',
  props: {
    placement: {
      type: String,
      default: 'top-end',
    },
    buttonStyle: {
      type: String,
      default: 'footer',
    },
  },
  computed: {
    memoryOptions() {
      return MEMORY_INSERT_OPTIONS
    },
  },
  methods: {
    onSelect(name) {
      if (name == null || name === '') return
      this.$emit('insert', String(name))
    },
  },
}
</script>

<style lang="scss" scoped>
.rp-insert-memory-dropdown {
  flex-shrink: 0;
}

.rp-insert-memory-btn {
  height: 28px !important;
  padding: 0 12px !important;
  border: 1px solid #91d5ff !important;
  border-radius: 4px !important;
  background: #e6f7ff !important;
  color: #1890ff !important;
  font-size: 14px !important;
  line-height: 26px !important;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover,
  &:focus {
    border-color: #1890ff !important;
    color: #0050b3 !important;
    background: #bae7ff !important;
    box-shadow: 0 1px 4px rgba(24, 144, 255, 0.18) !important;
  }

  &--footer {
    height: auto !important;
    min-height: 24px;
    padding: 4px 10px !important;
    border: none !important;
    border-radius: 4px !important;
    background: transparent !important;
    color: #5668f0 !important;
    font-size: 14px !important;
    line-height: 1.4 !important;
    box-shadow: none !important;

    &:hover,
    &:focus {
      border: none !important;
      background: #eef0fe !important;
      color: #404eec !important;
      box-shadow: none !important;
    }

    &:active {
      background: #e0e4fc !important;
      color: #3648d9 !important;
    }
  }
}
</style>

<style lang="scss">
.rp-insert-memory-transfer.ivu-select-dropdown {
  min-width: 200px;
}
.rp-insert-memory-transfer .ivu-dropdown-menu {
  padding: 4px 0;
}
.rp-insert-memory-transfer .ivu-dropdown-item.rp-insert-memory-item {
  padding: 10px 14px !important;
  line-height: normal !important;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #f5f7ff !important;
  }
}
.rp-insert-memory-transfer .rp-insert-memory-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  min-width: 150px;
}
.rp-insert-memory-transfer .rp-insert-memory-row__token {
  font-size: 14px;
  color: #1890ff;
  flex-shrink: 0;
}
.rp-insert-memory-transfer .rp-insert-memory-row__label {
  font-size: 14px;
  color: #262626;
}

.rp-insert-memory-btn.rp-insert-memory-btn--footer.ivu-btn-default:hover,
.rp-insert-memory-btn.rp-insert-memory-btn--footer.ivu-btn-default:focus {
  border-color: transparent !important;
  background: #eef0fe !important;
  color: #404eec !important;
}

.rp-insert-memory-btn.rp-insert-memory-btn--footer.ivu-btn-default:active {
  background: #e0e4fc !important;
  color: #3648d9 !important;
}
</style>
